import {createSlice} from '@reduxjs/toolkit';
import {httpPost, httpGet} from '../../../util/Rest';
import {AR} from '../../../constants/MicroServiceConstants';
import {PAYMENT_TYPE} from '../../../constants/Lookup';

const initialData = {
  reApplyCorrectionData: {},
  reApplyCorrectionStatus: null,
  dropDownData: {},
  isLoading: false,
  errorMsg: null,
  successMsg: null,
};

const slice = createSlice({
  name: 'reApplyCorrection',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    fetchReApplyCorrectionData: (state, action) => {
      state.reApplyCorrectionData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    postReApplyCorrectionData: (state, action) => {
      state.reApplyCorrectionStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.response;
    },
    fetchDropDownData: (state, action) => {
      state.dropDownData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    resetReApplyCorrection: (state) => {
      state.reApplyCorrectionStatus = null;
      state.isLoading = false;
    },
    fetchError: (state, action) => {
      state.errorMsg = action.payload;
      state.isLoading = false;
    },
    resetMsg: (state, action) => {
      state.successMsg = null;
      state.errorMsg = null;
      state.isLoading = false;
    },
  },
});

export default slice.reducer;

// Actions

const {
  fetchStart,
  fetchReApplyCorrectionData,
  postReApplyCorrectionData,
  fetchDropDownData,
  resetMsg,
  resetReApplyCorrection,
  fetchError,
} = slice.actions;

export const fetchReApplyCorrection = (accountnumber) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`${AR}/find/reapplycorrection/${accountnumber}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(fetchReApplyCorrectionData(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const postReApplyCorrection = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`${AR}/save/reapplycorrection`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postReApplyCorrectionData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const fetchDropdown = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    Promise.all([
      httpPost('lookup/find/all/lookup', {
        typeCode: [PAYMENT_TYPE],
      }),
    ])
      .then((data) => {
        const lookUpApiData = data && data[0] ? data[0] : null;
        if (lookUpApiData && lookUpApiData.status && lookUpApiData.status === 200) {
          dispatch(fetchDropDownData(lookUpApiData.data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};
export const resetMessage = () => {
  return (dispatch) => {
    dispatch(resetMsg());
  };
};
export const resetStatus = () => {
  return (dispatch) => {
    dispatch(resetReApplyCorrection());
  };
};
